import React, { useEffect, } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { withRouter } from 'react-router'

import AjaxLoading from "./AjaxLoading"

import { userActions } from '../actions/userActions';
import PropTypes from 'prop-types'

const HashLogin = ({ login }) => {
    const { hash } = useParams();

    useEffect( () => {
        login(hash)
    }, [])

    return (<div><AjaxLoading /></div>)
}
HashLogin.propTypes = {
    login: PropTypes.func,
    match: PropTypes.object,
}

const actionCreators = {
    login: userActions.loginUsingHash,
};


const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.user.isLoggedIn,
        user: state.user
    };
};

export default connect(mapStateToProps, actionCreators)(withRouter(HashLogin))
